import { HelperService } from '@/services/HelperService'

// Exports que se arman en la cola del backend (App\Reports\QueuedExport):
// los grandes, como inscritos de un evento con miles de personas, pasaban el
// minuto del gateway si se armaban dentro de la petición.
//
// Recibe la clave que devolvió el backend, consulta el estado cada
// `interval` ms y, cuando está listo, descarga desde la URL firmada de S3
// (ya trae el nombre del archivo). Rechaza si falla o si pasa `timeout`.
const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms))

export const waitForQueuedExport = async (
  key,
  { interval = 3000, timeout = 15 * 60 * 1000 } = {},
) => {
  const startedAt = Date.now()

  for (;;) {
    const {
      data: { status },
    } = await HelperService.reportExportStatus(key)

    if (status === 'completed') {
      const { data } = await HelperService.reportExportDownload(key)
      const link = document.createElement('a')
      link.href = data.download_url
      link.setAttribute('download', data.filename)
      document.body.appendChild(link)
      link.click()
      link.remove()
      return data
    }
    if (status === 'failed') {
      throw new Error('No se pudo generar el archivo. Inténtalo de nuevo.')
    }
    if (Date.now() - startedAt > timeout) {
      throw new Error('El archivo está tardando más de lo normal. Inténtalo más tarde.')
    }
    await sleep(interval)
  }
}
